import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import jobActions from '../actions';
import Api from '../../../../helpers/api';
import { sendRequest } from '../../../../helpers/saga';
import { logger } from '../../../../helpers/logger';
import notifications from '../../../../redux/notifications/actions';
import { tableConfig } from '../../../../settings';
import { t } from '../../../../i18n';

const bonusesApi = new Api('jobs/:job_id/payouts');
const assignBonusesApi = new Api('jobs/:job_id/payouts/assign');

function* loadData({ payload }) {
  try {
    const { id, page = 1, pageSize = tableConfig.pageSize, column, order, filter = '', cb } = payload;
    const result = yield call(
      sendRequest,
      bonusesApi.load,
      { search: { page, pageSize, column, order, filter }, id },
      notifications.REQUEST_ERROR,
    );

    if (result && result.data && result.data.success && result.data.success.data) {
      const { records, totalCount, filteredCount, sortableColumns, payouts } = result.data.success.data;
      yield put(
        actions.loadDataSuccess({
          workers: records,
          payoutsOptions: payouts,
          totalCount,
          filteredCount,
          sortableColumns,
        }),
      );

      if (cb) {
        cb();
      }
    }
  } catch (error) {
    logger.error(error);
  }
}

function* applyOtherPayouts({ payload }) {
  try {
    const { workers, id, cb } = payload;

    const shifts_payouts = {};

    workers.map(worker => {
      shifts_payouts[worker.id] = [];
      worker.assigned_payouts.map(payout => {
        shifts_payouts[worker.id].push({
          amount: parseFloat(payout.amount) || 0,
          billable: payout.billable,
          payout_id: payout.payout.id,
          organization_id: payout.organization.id,
        });

        return payout;
      });

      return worker;
    });

    const result = yield call(
      sendRequest,
      assignBonusesApi.updateItem,
      { data: { shifts_payouts }, id },
      notifications.REQUEST_ERROR,
    );

    if (result && result.data) {
      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.success_headline'),
          type: 'success',
          message: t('dash.common.notification.assigned_successfully', { item: t('dash.jobs.payout_title') }),
        }),
      );

      if (cb) {
        cb();
      }
      yield put(jobActions.loadData(payload));
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD_DATA, loadData), takeEvery(actions.APPLY_OTHER_PAYOUTS, applyOtherPayouts)]);
}
